module.exports = __webpack_public_path__ + "img/frame_degree_s_3.5af740b3.png";